(function headerResizeListener() {
    const announcementHeightOutput = document.querySelector('.announcement-bar');
    const headerHeightOutput = document.querySelector('.site-header');

    function initializeheaderResize() {
        const headerHeight = headerHeightOutput.offsetHeight;
        const announcementHeight = announcementHeightOutput.offsetHeight;
        const combinedHeight = headerHeight + announcementHeight;

        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
        document.documentElement.style.setProperty('--full-header-height', `${combinedHeight}px`);
    }

    // Initialize on page load
    initializeheaderResize();

    // Reinitialize on window resize
    window.addEventListener('resize', initializeheaderResize);
    window.addEventListener('scroll', initializeheaderResize);
})();

(function() {
    const headerMenuIcon = document.querySelector('.site-header__menu');

    headerMenuIcon.addEventListener('click', () => {
        const bodyMenu = document.querySelector('body');
        const htmlMenu = document.querySelector('html');
        bodyMenu.classList.toggle('menu-open');
        htmlMenu.classList.toggle('menu-open');
    });
})();

document.querySelectorAll('.btn--link-dropdown').forEach(button => {
    button.addEventListener('click', function() {
        // Close all other dropdowns
        document.querySelectorAll('.mobile-nav__item').forEach(item => {
            if (item !== this.parentElement) {
                item.classList.remove('menu-expanded');
                const otherButton = item.querySelector('.btn--link-dropdown');
                if (otherButton) {
                    otherButton.setAttribute('aria-expanded', 'false');
                }
            }
        });

        // Toggle the clicked dropdown
        const expanded = this.getAttribute('aria-expanded') === 'true' || false;
        this.parentElement.classList.toggle('menu-expanded', !expanded);
        this.setAttribute('aria-expanded', !expanded);
    });
});

jQuery(document).ready(function () {
    $('.readmore').click(function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.product-description-full');
        descriptionFull.style.display = 'block';
        var descriptionShort = document.querySelector('.product-description-short');
        descriptionShort.style.display = 'none';
    });
    $('.readless').click(function (event) {
        event.preventDefault();
        var descriptionFull = document.querySelector('.product-description-full');
        descriptionFull.style.display = 'none';
        var descriptionShort = document.querySelector('.product-description-short');
        descriptionShort.style.display = 'block';
    });

    $('.article-grid').masonry({
        itemSelector: '.article-grid-item'
    });
    $('.review-grid').masonry({
        itemSelector: '.review_grid__item'
    });
    $('.button-add').click(function () {
        $(this).addClass('btn-clicked').find('span').text('Added');
        setTimeout(function () { $('.button-add').removeClass('btn-clicked').find('span').text('Add') }, 3000);
    });
    $(document).on("click", ".action-with-text .button-add", function () {
        $(this).addClass('btn-clicked').siblings('.btn-add').addClass('hide').siblings('.btn-added').removeClass('hide');
        setTimeout(function () { $('.action-with-text .button-add').removeClass('btn-clicked').siblings('.btn-add').removeClass('hide').siblings('.btn-added').addClass('hide') }, 3000);
    });
    $('.site-footer__item-inner:not(.site-footer__item-inner--social_media) .h4').on('click', function (e) {
        $(this).parent().toggleClass("active");
    });
    $('.search-icon-toggle').on('click', function (e) {
        $(this).parent().toggleClass("search-active");
    });
    $(".search-form__input-wrapper input").click(function () {
        $(".mobile-nav--close").click();
        $(this).focus();
    });
    $('.other_menu').change(function () {
        var url = $('.other_menu').val();
        if (url) {
            window.open(url, '_blank');
        }
    });
    var $announcementSlider = $('.announcement-bar');

    if ($announcementSlider.length) {
        var currentSlide;
        var slidesCount;
        var sliderCounter = document.createElement('div');
        sliderCounter.classList.add('slider__counter');

        var updateSliderCounter = function (slick, currentIndex) {
            currentSlide = slick.slickCurrentSlide() + 1;
            slidesCount = slick.slideCount;
            if (slidesCount > 1) {
                $(sliderCounter).text(currentSlide + ' of ' + slidesCount)
            }
        };

        $announcementSlider.on('init', function (event, slick) {
            $announcementSlider.append(sliderCounter);
            updateSliderCounter(slick);
        });

        $announcementSlider.on('afterChange', function (event, slick, currentSlide) {
            updateSliderCounter(slick, currentSlide);
        });

        $announcementSlider.slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }

    $('.hc-banner-links > div').on('click', function() {
        var target = $($(this).data('href'));
        var headerHeight = $('header.site-header').innerHeight();
        var announcementHeight = $('.announcement-bar').innerHeight();
        if (target.length) {
          $('html, body').animate({
            scrollTop: target.offset().top - headerHeight - announcementHeight
          }, 800);
        }
    });

    if ($(".blog-item-slider").length) {
        $(".blog-item-slider").slick({
            dots: true,
            arrows: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    if ($(".testimonials-slider").length) {
        $(".testimonials-slider").slick({
            dots: true,
            arrows: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    if ($(".reassurances-slider").length) {
        $(".reassurances-slider").slick({
            dots: true,
            arrows: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    centerPadding: '111px 0 20px',
                    centerMode: true,
                    arrows: false,
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    centerPadding: '33.33% 0 20px',
                    centerMode: true,
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    if ($(".explore-category-list-slider").length) {
        $(".explore-category-list-slider").slick({
            dots: true,
            arrows: true,
            infinite: true,
            slidesToShow: 5,
            slidesToScroll: 5,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 640,
                settings: "unslick"
            }]
        });
    }

    if ($(".cms-featured-articles-slider > .shg-box-content").length) {
        $(".cms-featured-articles-slider > .shg-box-content").slick({
            dots: true,
            arrows: true,
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    if ($(".shg-category-row").length) {
        $(".shg-category-row").slick({
            dots: true,
            arrows: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    if ($(".shg-products-slider > .shg-box-content").length) {
        $(".shg-products-slider > .shg-box-content").slick({
            dots: true,
            arrows: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    if ($(".image-text-col-section > .shg-box-content > .shg-c > .shg-row").length) {
        $(".image-text-col-section > .shg-box-content > .shg-c > .shg-row").slick({
            dots: false,
            arrows: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: true
                }
            }]
        });
    }

    if ($(".ingredients-spotlight-slider > .shg-box-content").length) {
        $(".ingredients-spotlight-slider > .shg-box-content").slick({
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1025,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    slickLoaded();
    function sortbyFunction(x) {
        if (x.matches) {
            $('.filter-menu').append($('.filters-toolbar__item--count'));
            $('.sort-by').insertAfter('.pt-mobile-header');
        } else {
            $('.sort-by').insertAfter('.filter-menu-wrapper');
            $('.filters-toolbar__item--count').insertBefore('.pt-mobile-header');
        }
    }
    var x = window.matchMedia("(max-width: 767px)")
    sortbyFunction(x)
    x.addListener(sortbyFunction)

    function languageSelects(y) {
        if (y.matches) {
            $('.language-select').append($('.language-options'));
        } else {
            $('.language-options').insertAfter('#AccessibleNav');
        }
    }
    var y = window.matchMedia("(max-width: 1024px)")
    languageSelects(y)
    y.addListener(languageSelects)

    $(".site-footer__linklist-item a[href^='#popup-shipping-policy'").on('click', function (e) {
        e.preventDefault();
        $('body').addClass('popup-shipping-open');
    });
    $(".popup-shipping-close").on('click', function () {
        $('body').removeClass('popup-shipping-open');
    });

    $('[data-popup]').on('click', function (event) {
        $('body').addClass('popup-fragrance-open');

        var id = $(this).attr('data-popup');
        $('#' + id).addClass('active');
    });

    $(".popup-fragrance-close").on('click', function () {
        $('body').removeClass('popup-fragrance-open');
        $('.popup-fragrance').removeClass('active');
    });

    $(".form-open").on('click', function () {
        $('.form-info').addClass('form-filling');
    });
    $(".site-nav--has-dropdown").hover(
        function () {
            $('.site-header').addClass('header-blue');
        },
        function () {
            $('.site-header').removeClass('header-blue');
        }
    );

    $(".main-minicart").hover(
        function () {
            $('.mini-cart').addClass('minicart-open');
        },
        function () {
            $('.mini-cart').removeClass('minicart-open');
        }
    );

    function customerDetails(x) {
        if (x.matches) {
            $('.child_information').insertAfter('.customer-address-details');
        } else {
            $('.child_information').prependTo('.child_information-main');
        }
    }
    var x = window.matchMedia("(max-width: 1024px)")
    customerDetails(x)
    x.addListener(customerDetails)

    if ($(".filtered-items a").length) {
        $('.filtered-items a').each(function () {
            var text = $(this).text();
            $(this).text(text.replace(/-/g, ' '));
        });
    }

    if ($(".suggestion-slider").length) {
        $(window).on('resize orientationchange', function () {
            $('.suggestion-slider').slick('resize');
        });
    }

    if ($('.section-haircare-video').length) {
    // Store the offset of the section
    var distance = $('.section-haircare-video').offset().top;
    }
    // Get the video element
    var video = document.querySelector('.section-haircare-video video');

    // Check if the video element exists
    if (video) {
        // Handle scroll event
        $(window).scroll(function() {
            // Check if the scroll position is past the section
            if ($(this).scrollTop() >= distance) {
                // Play the video
                video.play();
            } else {
                // Pause the video
                video.pause();
            }
        });
    }
});

function setStickyHeaderPosition() {
    const announcementBar = document.querySelector('.announcement-bar');
    const header = document.querySelector('.site-header');

    if (!announcementBar || !header) return;

    const announcementBarHeight = announcementBar.clientHeight;

    if (document.body.classList.contains('header-sticky')) {
        header.style.top = `${announcementBarHeight}px`;
    }
}

function handleScroll() {
    const scrollTop = window.scrollY;

    if (scrollTop <= 108) {
        document.body.classList.add('body-wrapper');
    } else {
        document.body.classList.remove('body-wrapper');
    }

    if (scrollTop >= 108) {
        document.body.classList.add('header-sticky');
        setStickyHeaderPosition();
    } else {
        document.body.classList.remove('header-sticky');
        const header = document.querySelector('.site-header');
        if (header) header.style.top = '0';
    }
}

window.addEventListener('scroll', handleScroll);
window.addEventListener('resize', setStickyHeaderPosition);
window.addEventListener('load', () => {
    handleScroll(); // Run on page load
    setStickyHeaderPosition(); // In case the class is already applied
});

window.onload = function () {

    $('.geolocation #col-main').addClass('page-width');
    if (window.document.documentMode) {
        var img = $('img[srcset]');
        img.each(function () {
            this.src = $(this).attr('srcset');
        });
    }
}
function slickLoaded() {
    if ($(".three-item-slider").length) {
        $(".three-item-slider").slick({
            dots: true,
            arrows: true,
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true
                }
            }, {
                breakpoint: 992,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true
                }
            }, {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true
                }
            }]
        });
    }

    if ($(".hc-icon-items").length) {
        $(".hc-icon-items").slick({
            dots: true,
            arrows: false,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [{
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }]
        });
    }

    if ($(".hc-featured-items").length) {
        $(".hc-featured-items").slick({
            dots: true,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true
        });
    }

    $(".columns-wraper").slick({
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: true
            }
        }]
    });

    $(".press-list").slick({
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1
    });

    $(".product-certifications-items").slick({
        dots: true,
        arrows: true,
        infinite: false,
        slidesToShow: 7,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1190,
            settings: {
                slidesToShow: 6,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 850,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 580,
            settings: {
                slidesToShow: 2.5,
                slidesToScroll: 2
            }
        },
        {
            breakpoint: 374,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2
            }
        }]
    });
}
var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].relList.add('noreferrer', 'noopener');
    }
}




function slickify() {
    setTimeout(function () {
        $(".collection-faq .faq-plus-accordian").slick({
            dots: true,
            arrows: true,
            infinite: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: "unslick"
                }
            ]
        });
    }, 2000);
}
slickify();
$(window).resize(function () {
    var $windowWidth = $(window).width();
    if ($windowWidth > 768) {
        slickify();
    }
});

setTimeout(function () {

    var $this = $('.collection-faq .faqPlusAppFaq');
    if ($this.find('div').length > 2) {
        $('.collection-faq .faq-plus-app-container').append('<div><a href="javascript:;" class="showMore"></a></div>');
    }

    // If more than 2 Education items, hide the remaining
    $('.collection-faq .faq-plus-accordian .faqPlusAppFaq').slice(0, 3).addClass('shown');
    $('.collection-faq .faq-plus-accordian .faqPlusAppFaq').not('.shown').hide();
    $('.showMore').on('click', function () {
        $('.faqPlusAppFaq').not('.shown').toggle(300);
        $(this).toggleClass('showLess');
    });

}, 2300);

$('.site-nav__child-link').click(function () {
    hj('event', 'SubMenu - ' + $(this).text());
});

jQuery(document).ready(function () {

    $(document).on('click', '.cd-faq-categories a', function (e) {
        e.preventDefault();
        var menuHash = $(this).attr('href');
        $('html, body').animate({
            scrollTop: $(menuHash).offset().top - 15
        }, 50);
        $('.cd-faq-categories a').removeClass('selected');
        $(this).addClass('selected');
    });

    if ($(document).width() > 767) {
        var faqslider = setInterval(function () {
            if ($('.collection-faq .cd-faq-group').html() != undefined) {
                $('.collection-faq .cd-faq-group').each(function () {
                    let that = this;
                    let activeItem = $(this).children('.cd-faqitem').eq(1);
                    let slider = $(this).slick({
                        infinite: true,
                        slidesToShow: 3,
                        slidesToScroll: 1
                    });
                    slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                        let all = $(that).find('.cd-faqitem');
                        all.find('.zify-faq-question').removeClass('active');
                        all.find('.zify-faq-answer').css('display', 'none');
                        let curr = $(that).find('.cd-faqitem.slick-slide.slick-current.slick-active + .cd-faqitem.slick-slide.slick-active');
                        curr.find('.zify-faq-question').addClass('active');
                        curr.find('.zify-faq-answer').css('display', 'block');
                    });
                    $(this).show();
                })
                clearInterval(faqslider);
            }
        }, 1000)
    }
})


$(document).ready(function () {
    if ($(window).width() < 1024) {
        $('.reef-col-list').slick({
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            adaptiveHeight: true,
            prevArrow: '<span class="prev-arrow"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 2L2 12L11 22" stroke="#502C1D" stroke-width="3" stroke-linejoin="round"/></svg></span>',
            nextArrow: '<span class="next-arrow"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2 2L11 12L2 22" stroke="#502C1D" stroke-width="3" stroke-linejoin="round"/></svg></span>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]

        });
    }
});

$(".collection-faq ul").slick({
    dots: false,
    arrows: true,
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
        {
            breakpoint: 991,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 768,
            settings: "unslick"
        }
    ]
});

$(document).on('click', '.faq-block-product .collection-faq ul li .faq-content h4', function () {
    $(this).next().slideToggle();
    $(this).toggleClass('show');
});

$('.collection-faq ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {
    console.log('slide change');
    $('.faq-block-product .collection-faq ul li:not(.slick-current) .faq-answer').slideUp();
    $('.faq-block-product .collection-faq ul li h4').removeClass('show');
    $('.faq-block-product .collection-faq ul li.slick-current h4').addClass('show');
    $('.faq-block-product .collection-faq ul li.slick-current .faq-answer').slideDown();
});

/* Haircare landing js */
function setActiveProductLine(slideIndex, carousel) {
    const productLines = ["purifying", "nourishing", "defining"];
    const activeProductLine = productLines[slideIndex] || "defining";

    document.getElementById("haircare-lp").dataset.productLine = activeProductLine;

    // Find the index of the active product line
    const index = productLines.indexOf(activeProductLine);

    // Slide the carousel to the index of the active product line
    carousel.slick('slickGoTo', index);
}

function initializeSlick(selector) {
    var carousel = $(selector);
    var carouselSelectors = [".custom-carousel-slider", ".wrs-blocks-wrapper", ".pms-blocks-wrapper", ".pifs-blocks-wrapper", ".discover-carousel-slider", ".icc-blocks-wrapper"];
    var asNavForSelectors = carouselSelectors.filter(element => element !== selector).join(",");

    carousel.addClass("purifying");

    carousel.slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: asNavForSelectors
    });

    carousel.on('afterChange', function (event, slick, currentSlide) {
        setActiveProductLine(currentSlide, carousel);

        // Update arrow classes based on current slide index
        var prevArrow = carousel.find('.slick-prev');
        var nextArrow = carousel.find('.slick-next');

        if (currentSlide === 0) {
            prevArrow.hide().removeClass('nourishing defining').addClass('purifying');
            nextArrow.show();
        } else if (currentSlide === slick.slideCount - 1) {
            prevArrow.show();
            nextArrow.hide().removeClass('purifying nourishing').addClass('defining');
        } else {
            prevArrow.show().removeClass('purifying defining').addClass('nourishing');
            nextArrow.show().removeClass('purifying nourishing').addClass('defining');
        }
    });

    $(document).on('click', `${selector} .custom-slidea-arrows .span-arrow`, function () {
        const indexNumber = parseInt($(this).data('index'));
        carousel.slick('slickGoTo', indexNumber);
    });
}

$(document).ready(function () {
    // Function to parse URL parameters
    function getUrlParameter(name) {
        const params = new URLSearchParams(window.location.search);
        return params.has(name) ? params.get(name) : '';
    }

    // Check if the URL parameter exists
    const productLineParam = getUrlParameter('product-line');
    if (productLineParam) {
        // Define product lines array
        const productLines = ["purifying", "nourishing", "defining"];

        // Get the index of the product line parameter value
        let index = productLines.indexOf(productLineParam);

        // Get the active product line stored in <div id="haircare-lp" data-product-line="">
        const activeProductLine = document.getElementById("haircare-lp").dataset.productLine;

        // If the active product line doesn't match the query parameter, invoke setActiveProductLine
        if (activeProductLine !== productLineParam) {
            // If the product line parameter is not found, default to "defining"
            if (index === -1) {
                index = 2; // "defining" index
            }
            setActiveProductLine(index, $('.custom-carousel-slider')); // Pass jQuery selector to setActiveProductLine
        }
    }

    $('#haircare-lp a[href*=\\#]:not([href=\\#])').on('click', function () {
        var target = $(this.hash);
        var getAnnouncementHeight = document.querySelector('.announcement-bar').offsetHeight;
        var getHeaderHeight = document.querySelector('.site-header').offsetHeight;
        var totalHeaderHeight = getAnnouncementHeight + getHeaderHeight;
        target = target.length ? target : $('[name=' + this.hash.substring(1) + ']');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top - totalHeaderHeight
            }, 1000);
            return false;
        }
    });
});

initializeSlick('.custom-carousel-slider');
initializeSlick('.wrs-blocks-wrapper');
initializeSlick('.pms-blocks-wrapper');
initializeSlick('.pifs-blocks-wrapper');
initializeSlick('.discover-carousel-slider');
initializeSlick('.icc-blocks-wrapper');

const observer = new MutationObserver((mutations, obs) => {
    const popupContainer = document.getElementById('freegifts-main-popup-container');

    if (popupContainer) {
        const closeButton = popupContainer.querySelector('.sca-close-modal-fg');

        if (closeButton && !popupContainer.querySelector('.freegifts-close-button')) {
            const customClose = document.createElement('button');
            customClose.type = 'button';
            customClose.className = 'freegifts-close-button';
            customClose.setAttribute('aria-label', 'Close free gifts popup');
            customClose.innerHTML = '<span class="icon__fallback-text">Close</span><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><path fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.515 11.515l16.97 16.97m-16.97 0l16.97-16.97"/></svg>';

            customClose.addEventListener('click', () => {
                closeButton.click();
            });

            closeButton.parentNode.insertBefore(customClose, closeButton);

            obs.disconnect();
        }
    }
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});
